import React from 'react'
import { Link } from 'react-router'
import './index.less'
import { setDocumentTitle, setUidToken } from 'src/helper/tool'
import { history } from 'src/core/router'
import localstorage from 'src/helper/localstorage'
import { jumpToUser, jumpToRoom } from 'src/helper/webviewFun'

export default class extends React.Component {
  constructor(props) {
    super(props)
  }

  state = {
    uid: 0,
    accesstoken: '',
    lang: {},
    language: 'en'
  }

  async componentWillMount() {
    await setUidToken(this.props.location.query)
    
    setTimeout(function () {
      setDocumentTitle(`Child Safety Policy`)
    }, 1000)
    
    // let { uid, accesstoken } = localstorage.get('userInfo')
    // this.setState({
    //   uid: uid,
    //   accesstoken: accesstoken
    // })
    
  }

  componentDidMount() {
    window.scroll(0, 0)
  }

  jump = () => {
    return
    jumpToUser.bind(this, 433031)
  }

  render() {
    return (
      <div className="policy">
 <h1>Child Safety Policy</h1>

We strictly prohibit the creation, upload, or distribution of any content that exploits or harms children, including all forms of child sexual abuse material. If you encounter such content on this app, please click the appropriate report button so we can promptly review and remove it. You may also contact our administrators at <span class="contact" onClick={this.jump.bind(this)}>service@yayya.live</span>.

<br/><br/>

The use of this app for any activity that endangers children is strictly forbidden. This includes, but is not limited to, using the platform to promote or engage in predatory behavior, such as:

<br/><br/>
<ul>
  <li>Inappropriate interactions with children (e.g., touching or caressing).</li>
  <li>Grooming (e.g., forming online relationships with children to pursue sexual contact or exchange explicit images).</li>
  <li>Sexualization of minors (e.g., content that depicts, encourages, or promotes child sexual abuse or portrays children in a sexually exploitative way).</li>
  <li>Sextortion (e.g., threatening or blackmailing a child using real or fake intimate images).</li>
  <li>Child trafficking (e.g., grooming or promoting children for commercial sexual exploitation).</li>
  <li>If any app is found to contain child sexual abuse material, we will take immediate action. If you suspect a child is in danger, being abused, exploited, or trafficked, please report it to us at <span class="contact" onClick={this.jump.bind(this)}>service@yayya.live</span>.</li>
</ul>

<br/>

Apps directed at children must not contain mature or harmful themes. This includes, but is not limited to:

<br/>
<ul>
  <li>Excessive violence or gore.</li>
  <li>Depictions or encouragement of dangerous or harmful activities.</li>
  <li>Promotion of negative body image or self-esteem, including content featuring plastic surgery, weight loss, or cosmetic enhancements intended for entertainment.</li>
</ul>

<br/>

To report any child safety concerns, please contact: <span class="contact" onClick={this.jump.bind(this)}>service@yayya.live</span>
<br/><br/>
       </div>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/app/child_safety_policy/index.js